import React from 'react';
interface DashboardCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
}
export function DashboardCard({
  title,
  subtitle,
  children,
  icon,
  className = ''
}: DashboardCardProps) {
  return <div className={`bg-white rounded-lg shadow-sm border border-gray-200 p-4 ${className}`} data-id="element-653">
      <div className="mb-4" data-id="element-654">
        <div className="flex items-center" data-id="element-655">
          {icon}
          <h3 className="font-medium text-gray-800" data-id="element-656">{title}</h3>
        </div>
        {subtitle && <div className="text-sm text-gray-500" data-id="element-657">{subtitle}</div>}
      </div>
      {children}
    </div>;
}